"use client";

import { useEffect, useState } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import { parseConsent } from "@/components/site/cookie-consent/utils";
import { CONSENT_UPDATED_EVENT } from "@/components/ui/cookie-consent-events";

const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID;

function consentAllowsIntercom(): boolean {
  const { consented, prefs } = parseConsent();
  return consented && prefs.functional;
}

// Loads the Intercom Messenger once consent allows it, mirroring GtmLoader:
// opt-in geos grant via CookieYes's banner (consent_update event ->
// ConsentSync -> CONSENT_UPDATED_EVENT), non-targeted geos get an
// implied-grant cookie at SDK boot, and repeat visitors pass the mount-time
// check directly from the cookie. Intercom sets its own cookies and
// identifies visitors, so it's gated on the "functional" category rather
// than loaded unconditionally like the UserWay accessibility widget.
export default function IntercomLoader() {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (load) return;
    const check = () => {
      if (consentAllowsIntercom()) setLoad(true);
    };
    check();
    window.addEventListener(CONSENT_UPDATED_EVENT, check);
    return () => window.removeEventListener(CONSENT_UPDATED_EVENT, check);
  }, [load]);

  useEffect(() => {
    if (!load || !INTERCOM_APP_ID) return;
    Intercom({ app_id: INTERCOM_APP_ID });
  }, [load]);

  return null;
}
